export default function getQueryParam(key, qst = window.location.search) {
    return qst.slice(
        qst.indexOf(key + "=") + key.length + 1,
        qst.slice(qst.indexOf(key + "=") + key.length + 1).indexOf("&") !== -1
            ? qst.slice(qst.indexOf(key + "=") + key.length + 1).indexOf("&") + key.length + 2
            : qst.length
    );
}
